export var SET_QUERY = '@query/SET_QUERY';
export var SERIALIZE_QUERY = '@query/SERIALIZE_QUERY';
export var POST_PROCESSING_FINISHED = '@query/POST_PROCESSING_FINISHED';
export var RESET_QUERY = '@query/RESET_QUERY';
export var SELECT_EVENT_COLLECTION = '@query/SELECT_EVENT_COLLECTION';
export var SELECT_ANALYSIS = '@query/SELECT_ANALYSIS';
export var SELECT_TARGET_PROPERTY = '@query/SELECT_TARGET_PROPERTY';
export var SET_PERCENTILE = '@query/SET_PERCENTILE';
export var SET_TIMEFRAME = '@query/SET_TIMEFRAME';
export var SET_GROUP_BY = '@query/SET_GROUP_BY';
export var SET_INTERVAL = '@query/SET_INTERVAL';
export var SET_ORDER_BY = '@query/SET_ORDER_BY';
export var SET_LIMIT = '@query/SET_LIMIT';
export var RESET_EXTRACTION = '@query/RESET_EXTRACTION';
export var SET_EXTRACTION_LIMIT = '@query/SET_EXTRACTION_LIMIT';
export var SET_PROPERTY_NAMES = '@query/SET_PROPERTY_NAMES';
export var SET_FILTERS = '@query/SET_FILTERS';
export var SELECT_TIMEZONE = '@query/SELECT_TIMEZONE';
export var ADD_FUNNEL_STEP = '@query/ADD_FUNNEL_STEP';
export var SELECT_FUNNEL_STEP_EVENT_COLLECTION = '@query/SELECT_FUNNEL_STEP_EVENT_COLLECTION';
export var REMOVE_FUNNEL_STEP = '@query/REMOVE_FUNNEL_STEP';
export var UPDATE_FUNNEL_STEP = '@query/UPDATE_FUNNEL_STEP';
export var CLONE_FUNNEL_STEP = '@query/CLONE_FUNNEL_STEP';
export var SET_FUNNEL_STEPS = '@query/SET_FUNNEL_STEPS';
export var SET_FUNNEL_STEP_FILTERS = '@query/SET_FUNNEL_STEP_FILTERS';
export var CHANGE_FUNNEL_STEPS_ORDER = '@query/CHANGE_FUNNEL_STEP_ORDER';
export var ADD_FUNNEL_STEP_FILTER = '@query/ADD_FUNNEL_STEP_FILTER';
export var UPDATE_FUNNEL_STEP_FILTER = '@query/UPDATE_FUNNEL_STEP_FILTER';
export var REMOVE_FUNNEL_STEP_FILTER = '@query/REMOVE_FUNNEL_STEP_FILTER';
export var UPDATE_FUNNEL_STEP_TIMEZONE = '@query/UPDATE_FUNNEL_STEP_TIMEZONE';
export var ADD_FILTER = '@query/ADD_FILTER';
export var UPDATE_FILTER = '@query/UPDATE_FILTER';
export var REMOVE_FILTER = '@query/REMOVE_FILTER';
export var DEFAULT_ANALYSIS = 'count';
export var DEFAULT_TIMEFRAME = 'this_14_days';
export var DEFAULT_TIMEZONE = 'UTC';
export var DEFAULT_EXTRACTION_LIMIT = 100;
export var DEFAULT_FILTER = {
  propertyName: undefined,
  operator: undefined,
  propertyValue: undefined,
  propertyType: undefined
};
export var DEFAULT_FUNNEL_STEP = {
  eventCollection: undefined,
  actorProperty: undefined,
  timeframe: DEFAULT_TIMEFRAME,
  timezone: DEFAULT_TIMEZONE,
  filters: [],
  inverted: false,
  optional: false,
  withActors: false
};